import React, { useEffect, useState } from 'react';
import { Login } from './Login';
import { API_ORG_IMPERSONATE } from '../../settings';
import { schemas } from '../../store/schemas';
import { fetchData } from "../../utils";
import { findIndex } from 'lodash';
import { useDispatch } from 'react-redux';
import { resetState } from '../../store';
import { useKeycloak } from '@react-keycloak/web';

const LoginContainer = ({ location, history }) => {
    const dispatch = useDispatch();
    const { keycloak } = useKeycloak();
    const initialState = {
        error: null,
        orgs: []
    };
    const [ state, setState ] = useState(initialState);
    const { search, pathname } = location;
    const searchParams = new URLSearchParams(search);
    const switchOrg = searchParams.get("switch-org");
    let from = searchParams.get('from');
    if (from === null) from = "/";

    useEffect(() => {
        if (switchOrg) {
            getOrgsList();
        }
        dispatch(resetState());
    }, [ switchOrg ]);

    useEffect(() => {
        if (!switchOrg && keycloak.authenticated) {
            history.push(from)
        }
    }, [keycloak.authenticated]);

    const onSubmit = ({ org }) => {
        if (switchOrg) {
            onImpersonate(org);
        } else  {
            keycloak.login({ redirectUri: window.location.origin + from})
        };
    };

    const onCancel = (e) => {
        e.preventDefault();
        history.push(decodeURIComponent(from));
    };

    const getOrgsList = () => {
        let orgs = [];
        fetchData(API_ORG_IMPERSONATE, {}, schemas.ORGS_TO_IMPERSONATE)
            .then(data => {
                if (data.entities && data.entities.organisations) {
                    orgs = Object.values(data.entities.organisations);
                }
                setState(state => ({ ...state, orgs: orgs }));
            })
            .catch((e) => {
                if (e.code === 401) {
                    history.push(pathname);
                } else {
                    setState(state => ({ ...state, error: `Error ${e.code}: ${e.message}.`}))
                };
            });
    }

    const onImpersonate = (org) => {
        fetchData(API_ORG_IMPERSONATE, {
            method: "DELETE"
        }, {})
        .then(response => {
            if (findIndex(state.orgs, { alias: org, defaultOrg: true }) > -1) {
                history.push(decodeURIComponent(from));
            } else {
                fetchData(API_ORG_IMPERSONATE, {
                    method: 'PUT',
                    headers: {
                        'X-Org-Alias': org
                    }
                }, {})
                .then(response => {
                    history.push("/");
                })
                .catch((e) => setState(state => ({ ...state, error: `Error ${e.code}: ${e.message}.`})));
            }

        })
    };

    return(
        <Login
            error={state.error}
            onSubmit={onSubmit}
            onCancel={onCancel}
            switchOrg={switchOrg}
            orgs={state.orgs}
        />
    );
};

export { LoginContainer };